export var defaultConfig = {
  loadOnStart: {
    cart: true,
    checkout: true
  }
};